import React from 'react';
import { midas } from '@resurs/midas';
import { classNames } from '@resurs/hephaestus';
const cardKindToMidasClassName = (kind) => ({
    primary: midas.cardPrimary,
    danger: midas.cardDanger,
    warning: midas.cardWarning,
    success: midas.cardSuccess,
    info: midas.cardInfo,
    style: midas.cardStyle,
}[kind]);
const Card = ({ children, actions, tabIndex = 0, title, subtitle, kind, center = false, attention = false, dataCy, }) => (React.createElement("div", { className: classNames(midas.card, attention && midas.cardAttention, kind && cardKindToMidasClassName(kind)), tabIndex: tabIndex, "data-cy": dataCy },
    (title || subtitle) && (React.createElement("div", { className: midas.cardHeader },
        title && (React.createElement("div", { className: classNames(midas.cardTitle, center && midas.textCenter) }, title)),
        subtitle && (React.createElement("div", { className: classNames(midas.cardSubtitle, center && midas.textCenter) }, subtitle)))),
    React.createElement("div", { className: midas.cardBody }, children),
    actions && React.createElement("div", { className: midas.cardFooter }, actions)));
export default Card;
